import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import dock from './modules/dock';
import user from './modules/user';
import error from './modules/error';
import confirm from './modules/confirm';
import connection from './modules/connection';
import common from './modules/common';
import navigation from './modules/navigation';
import shippingOfflineLocation from './modules/shipping_offline_location';
import loadApproval from './modules/load_approval';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    dock,
    user,
    error,
    confirm,
    connection,
    common,
    navigation,
    shippingOfflineLocation,
    loadApproval
  }
});
